import React,{ useState } from 'react';
import { MdClose } from "react-icons/md";


function Announcement() {

    const [announces,setAnnounces] = useState(true);

  return (

  
        <div className={announces ?'announce_whole':"d-none"}>
         <div className='rolling_track'>
            <div className='rolling_cont'>
                <p className='mb-0'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled,it to make a type specimen book. It has survived not only five centuries. </p>
            </div>
         </div>
         <MdClose className='announce_close' onClick={()=>setAnnounces(false)}/>
        </div>


   
  )
}

export default Announcement;